var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-benefit-template" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "queryFormRef",
                  attrs: { model: _vm.tableFrom, inline: "" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "规格名称：", prop: "specName" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入规格名称", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.specName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "specName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.specName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "会员卡：", prop: "memberCardId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择会员卡", clearable: "" },
                          model: {
                            value: _vm.tableFrom.memberCardId,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "memberCardId", $$v)
                            },
                            expression: "tableFrom.memberCardId",
                          },
                        },
                        _vm._l(_vm.memberCardList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.cardName + "-" + item.code,
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearchList },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("queryFormRef")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "detailSection divBox" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "tabNumWidth",
              attrs: { data: _vm.tableData.data, size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  type: "index",
                  width: "50",
                  index: function (index) {
                    return (
                      (_vm.tableFrom.page - 1) * _vm.tableFrom.limit + index + 1
                    )
                  },
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "specName", label: "规格名称", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "id", label: "商品ID (SPU ID)", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "specId",
                  label: "规格ID (SKU ID)",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "cost", label: "成本价 (元)", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "otPrice",
                  label: "建议售价 (元)",
                  width: "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "redLinePrice",
                  label: "划线价 (元)",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "商城售价 (元)", width: "110" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "servicePrice",
                  label: "平台服务费",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operationPrice",
                  label: "商品运营费",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "brokerage",
                  label: "商城基本利润",
                  width: "110",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "otherPrice", label: "其他费用", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "totalCost", label: "总成本", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalProfit",
                  label: "预计毛利润",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalProfitRate",
                  label: "预计利润率",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              width: "230",
                              trigger: "hover",
                              disabled: !scope.row.flag,
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "totalProfit-rate-tips" },
                              [
                                _vm._v(
                                  "低于该会员卡的最低返现比例" +
                                    _vm._s(scope.row.lowGear) +
                                    "%"
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                class: {
                                  "totalProfit-rate-color": scope.row.flag,
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.totalProfitRate) + "%")]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "memberCardCode",
                  label: "会员卡编号",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "memberCardName",
                  label: "会员卡名称",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "zqDeduction",
                  label: "预计债权抵扣金额",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "zbDeduction",
                  label: "预计债务化债金额",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalReturn",
                  label: "预计返现金额",
                  width: "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "couponReturn",
                  label: "预计返现金券金额",
                  width: "130",
                },
              }),
              _c(
                "template",
                { slot: "empty" },
                [_c("el-empty", { attrs: { description: "暂无数据~" } })],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [10, 20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }